import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer } from '@topconagriculture/frontend-utils';

import { previewLoadReport, resetPDFURL } from './pdf.actions';

export type PDFState = {
  readonly url: string | null;
};

export const initialState: PDFState = {
  url: null,
};

const pdfReducer = createReducer(initialState, {
  [previewLoadReport.done.type]: (state: PDFState, action: Action<string>) => dotProp.set(state, 'url', action.payload),
  [resetPDFURL.type]: (state: PDFState) => dotProp.set(state, 'url', null),
});

export default pdfReducer;
